module.exports = __webpack_public_path__ + "static/media/03.858fc248.svg";